import { Box, HStack, VStack } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

import { primitive } from 'styles/constants';

type ImageSize = 'small' | 'medium' | 'large' | 'extraLarge';

const ImageSizeMap: Record<ImageSize, string> = {
  small: '55px',
  medium: '60px',
  large: '70px',
  extraLarge: '80px',
};

export const Wrapper = Box.withConfig({ flex: 1 });

export const ImageContainer = Box.withConfig<{ $size?: ImageSize }>(({ $size }) => ({
  padding: 0,
  margin: 0,
  marginRight: 3,
  height: $size ? ImageSizeMap[$size] : ImageSizeMap.medium,
  width: $size ? ImageSizeMap[$size] : ImageSizeMap.medium,
  // for quantity badge positioning
  position: 'relative',
  justifyContent: 'center',
}));

export const DetailsContainer = VStack.withConfig({
  flexShrink: 1,
  alignSelf: 'center',
  justifyContent: 'center',
});

export const QuantityBadge = HStack.withConfig({
  position: 'absolute',
  background: primitive.$bbqBrown,
  height: 5,
  color: 'white',
  borderRadius: 'full',
  // offset over image borders a bit
  top: '-3px',
  left: '-3px',
  alignItems: 'center',
});

export const ProductName = withTypography({
  variant: 'headerTwo',
  m: '$0',
  p: '$0',
  numberOfLines: 2,
  fontSize: 16,
  lineHeight: 22,
});

export const ProductDescription = withTypography({ variant: 'copyTwo', m: '$0', p: '$0' });

export const Layout = Box.withConfig<{ $inline?: boolean }>(({ $inline }) => ({
  flexDirection: $inline ? 'row' : 'column',
  justifyContent: $inline ? 'flex-start' : 'center',
  alignItems: 'flex-start',
}));

export const SelectionsListItem = withTypography({
  fontSize: 'xs',
  lineHeight: 14,
  style: { width: '100%' },
});
